import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IUserProfileComplete } from 'src/app/shared/interfaces/profile.interface';
import { ICommentTribeNested } from 'src/app/shared/interfaces/comment-tribe.interface';
import { AttributesItribes } from 'src/app/shared/interfaces/tribe.interface';
import { UserProfileService } from 'src/app/services/user-profile.service';
import { InputCommentTribeComponent } from '../../input-comment-tribe/input-comment-tribe.component';
import { CommentsTribeService } from 'src/app/services/comments-tribe.service';
import { CardCommentTribeResponseComponent } from '../card-comment-tribe-response/card-comment-tribe-response.component';
import { RelativeDateFormatPipe } from 'src/app/shared/pipes/relative-date-format.pipe';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-card-comment-tribe',
  standalone: true,
  imports: [
    CommonModule,
    InputCommentTribeComponent,
    CardCommentTribeResponseComponent,
    RelativeDateFormatPipe,
  ],
  templateUrl: './card-comment-tribe.component.html',
  styleUrls: ['./card-comment-tribe.component.scss'],
})
export class CardCommentTribeComponent {
  @Input() fatherThread: string = '';
  @Input() data: ICommentTribeNested = {} as ICommentTribeNested;
  @Output() commentCreatedEvent = new EventEmitter<ICommentTribeNested>();

  @Input() loading: boolean = true;
  url = '';
  name = '';
  displayName = '';
  toComment = false;
  urlImageProfileLogued: string | null = '';
  maxCommentResponsesDeep = 3;

  constructor(
    private userProfileService: UserProfileService,
    private commentsTribeService: CommentsTribeService
  ) {}

  ngOnInit(): void {
    //card resolve user data
    if (sessionStorage.getItem(this.data.user_uid.toString())) {
      // console.log('cache loading...' );
      const dataProfileCache = JSON.parse(
        sessionStorage.getItem(this.data.user_uid) || '{}'
      );
      this.url = dataProfileCache.url;
      this.name = dataProfileCache.name;
      this.displayName = dataProfileCache.field_display_name;
      this.loading = false;
      this.urlImageProfileLogued = localStorage.getItem('userImg') || null;
    } else {
      this.userProfileService
        .getUserProfileCompleteById(this.data.user_uid)
        .subscribe((dataProfile: IUserProfileComplete) => {
          // console.log("card comment data profile",dataProfile)
          this.url = dataProfile.user_picture?.url
            ? dataProfile.user_picture.url
            : '../../../../assets/images/user.png';
          this.name =
            dataProfile.field_name + ' ' + dataProfile.field_lastname;
          this.displayName = dataProfile.field_display_name;
          this.loading = false;
          if (dataProfile.field_name && dataProfile.user_picture.url) {
            const dataProfileStorage = {
              tribe_edutegia: true,
              url: dataProfile.user_picture.url,
              name: dataProfile.field_name + ' ' + dataProfile.field_lastname,
              field_display_name: dataProfile.field_display_name,
            };
            sessionStorage.setItem(
              this.data.user_uid,
              JSON.stringify(dataProfileStorage)
            );
          }
        });
      this.urlImageProfileLogued = localStorage.getItem('userImg') || null;
    }
  }
  onComment() {
    this.toComment = !this.toComment;
  }

  onReponseComment(subject: any) {
    // console.log("card llego comment",subject);
    this.commentsTribeService
      .createCommentTribe(this.data.uuid_tribe, subject, this.fatherThread)
      .subscribe((data ) => {
          this.commentsTribeService.getResultCommentCreated$.next(data.data);
      },(error)=>{
        console.log(error.error);
        if(error.error.errors[0].status==="422"
          ){
            Swal.fire({
              icon: 'warning',
              title: '¡Oops!',
              text: error.error.errors[0].detail.replaceAll('subject.0.value:',""),
            });
          }
      });
  }
}

// const element = data;
// console.log("comment result in root ",element);
// const dataForNested = {
//   id_tribe: element.relationships.entity_id.data.id,
//   uuid_tribe: element.relationships.entity_id.data.id,
//   target_uuid: element.relationships.entity_id.data.id,
//   id_comment: element.id,
//   // field_name:element.attributes.field_name,
//   status: element.attributes.status,
//   subject: element.attributes.subject,
//   user_uid: element.relationships.uid.data.id,
//   // entity_id:element.attributes.entity_id[0].target_id,
//   created: element.attributes.created,
//   changed: element.attributes.changed,
//   thread: element.attributes.thread,
//   thread_array: element.attributes.thread
//     .replaceAll('/', '')
//     .split('.'),
//   comment_body: element.attributes.comment_body.value,
// };
// this.dataModal.comments = getNestTribeComments([...this.OriginalComments,dataForNested]).reverse();
